import axios from '../axios';

export default {
  namespaced: true,
  state: () => ({
    resources: null
  }),
  actions: {
    async get_all() {
      try {
        const response = await axios.get(`/job`);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async edit(_, id) {
      try {
        const response = await axios.get(`/job/${id}/edit`);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async store(_, payload) {
      try {
        const response = await axios.post(`/job`, payload);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async update(_, payload) {
      try {
        const response = await axios.post(`/job/${payload.get('id')}`, payload);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async store_result(_, payload) {
      try {
        const response = await axios.post(`/job/store_result`, payload);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async update_result(_, payload) {
      try {
        const response = await axios.post(`/job/update_result`, payload);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async delete_announcement(_, id) {
      try {
        const response = await axios.delete(`/job/delete_announcement/${id}`);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async delete_result(_, id) {
      try {
        const response = await axios.delete(`/job/delete_result/${id}`);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async change_status(_, form) {
      try {
        const response = await axios.post(`/job/change_status`, form);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async get_resources({ commit }) {
      try {
        const { data } = await axios.get('/job/resources');

        commit('SET_RESOURCES', data);
      } catch ({ response }) {
        throw response.data;
      }
    }
  },
  mutations: {
    // SET_NEWS_TYPES(state, data) { state.news_types = data },
    SET_RESOURCES(state, data) { state.resources = data }
  }
    
}